import React, { useContext, useState } from 'react';
import {useAuth} from '../utils/AuthContext/AuthContext'; 
import { FormContext } from '../utils/FormContext';
import { useMediaQuery } from 'react-responsive';
import config from '../utils/config.js';
import AddToCalendarButton from './AddCalendar.jsx';

// ASSETS
import CalendarSVG from '../assets/Calendar';
import ScheduleSVG from '../assets/Schedule';

function UpcomingDates({ formData, userId }) {
    // const [checkedDates, setCheckedDates] = useState({});  // Track which dates are checked
    const [showAll, setShowAll] = useState(false);
    const [showAllPastDates, setShowAllPastDates] = useState(false);
    const { token } = useAuth();
    const { setFormData } = useContext(FormContext);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    // console.log("userId", userId);

    const excludeDates = ['acceptance_deadline_date', 'mineral_rights_examination_deadline', 'water_rights_examination_deadline', 'seller_or_private_financing_deadline', 'right_of_first_refusal_deadline', 'association_document_deadline', 'association_documents_termination_deadline', 'seller_property_disclosure_deadline', 'lead_based_paint_disclosure_deadline', 'disapproval_of_buyers_credit_information_deadline', 'existing_loan_deadline', 'existing_loan_termination_deadline', 'loan_transfer_approval_deadline', 'property_insurance_termination_deadline', 'conditional_sale_deadline'];
    const formId = formData.formId; 

    // Check if formData is defined and belongs to the current user
    if (!formData || formData.userId !== userId || formData?.packetDetails?.documentGroup?.status !== "completed") {
        return null;  // Or some loading indicator
    }

    // Initialize checkedDates state based on the checked values in the dateFields object
    const [checkedDates, setCheckedDates] = useState(
        Object.fromEntries(
            Object.entries(formData.data.dateFields).map(([title, field]) => [title, field.checked])
        )
    );
    
    // Convert the dateFields object to an array and filter and sort the dates
    const allDates = formData.data && formData.data.dateFields ? Object.entries(formData.data.dateFields)
    .filter(([title, {date}]) => !isNaN(new Date(date)) && !excludeDates.includes(title))
    .sort((a, b) => new Date(a[1].date) - new Date(b[1].date))
    .map(([title, data]) => ({title, ...data})) : [];

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // const currentAndUpcomingDates = allDates.filter(([title, date]) => new Date(date) >= today);
    const upcomingDates = allDates.filter(({date}) => new Date(date) >= today);
    const pastDates = allDates.filter(({date}) => new Date(date) < today);

// Handle checkbox changes
const handleCheck = (title) => {
    setCheckedDates(prev => {
        const newCheckedDates = {...prev};
        newCheckedDates[title] = !newCheckedDates[title];

        // Create a copy of the dateFields object
        const updatedDateFields = {...formData.data.dateFields};

        // Update the checked property of the specific date field in the copied object
        updatedDateFields[title] = {
            ...updatedDateFields[title],
            checked: newCheckedDates[title]
        };

        // Make API call to update data in MongoDB
        // fetch(`http://localhost:5000/api/formdata/${formId}`, {
            fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                userId: userId,
                data: {
                    dateFields: updatedDateFields
                }
            }),
        })
        .then(response => response.json())
        .then(data => {
            // console.log('Success:', data);
            console.log('Success');
        })
        .catch((error) => {
            console.error('Error:', error);
        });

        return newCheckedDates;
    });
};

    function formatTitle(title) {
        if (typeof title !== 'string') {
            // Return a default value or throw an error
            return 'Default Title';
        }
    
        return title
            .replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
            .replace(/ Deadline$/, '');  // Remove " Deadline" from the end of the title
    }

    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        return utcDate.toLocaleDateString(undefined, options);
    }

    function formatDateForMobile(dateString) {
        const date = new Date(dateString);
        const month = date.getUTCMonth() + 1; // getUTCMonth() returns 0-11
        const day = date.getUTCDate();
        return `${month}/${day}`; // mm/dd format
    }

    return (
        <div className="px-2 py-3 md:px-6 md:py-4 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] max-h-full md:max-h-[875px] overflow-y-auto mb-4 md:mb-10 md:w-[1100px]">
        <div className='flex-col'>
            <div className="flex flex-col">
                <h1 className='mb-2 text-lg md:text-xl text-slate-600'>Key Deadlines</h1>
                <div className='inline-flex justify-between mb-2 items-center'>
                    <span className='font-[Inter] md:pr-6 text-[16px] md:text-2xl font-semibold max-w-[220px] md:max-w-full overflow-hidden whitespace-nowrap text-ellipsis'>
                        {formData.data.address ? Object.values(formData.data.address).join(', ') : ''}</span>
                    <AddToCalendarButton dates={upcomingDates}/>
                </div>
                {/* CHECK FOR STATE SPECIFIC HOLIDAYS */}
                {formData.data.address.state === 'CO' && (
                <div className='flex items-center mb-2'>
                    <span className='text-xs text-slate-500'><b>Note:</b> Date's do not account for Colorado holiday's, President's Day and Cabrini Day </span>
                </div>
                )}
                <div className='mb-4'>
                    <p className='text-[14px] md:text-[16px] text-slate-600 mb-1'>Next Deadline:</p>
                    <div className="bg-blue-100 text-blue-600 rounded-xl p-1 md:p-1.5 inline-block text-sm md:text-[16px] mt-1">
                        {upcomingDates?.length > 0 ? `${formatDate(upcomingDates[0].date)} - ${formatTitle(upcomingDates[0].title)}` : 'No upcoming dates'}
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto'>
                {upcomingDates?.length > 1 && (
                    <table className='w-full table-auto bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]'>
                        <thead>
                            <tr className='bg-slate-200 h-[35px] md:h-[50px] items-center rounded-t-lg'>
                                <th className='p-2 md:p-4'></th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Date</th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Name</th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(showAll ? upcomingDates : upcomingDates.slice(1, 6)).map(({title, date, checked}) => {
                                const formattedTitle = formatTitle(title);
                                const formattedDate = formatDate(date);
                                const formattedDateMobile = formatDateForMobile(date);
                                const isChecked = checkedDates[title] || false; 
                                const itemDate = new Date(date);
                                let status;
                                let statusClasses; 

                                if (isChecked) {
                                    status = "Completed";
                                    statusClasses = "bg-green-100 text-green-600 rounded-xl text-center text-[12px] md:text-[14px] p-1 md:px-1.5 w-auto h-auto";
                                } else if (itemDate > today) {
                                    status = "Upcoming";
                                    statusClasses = "bg-blue-100 text-blue-600 rounded-xl text-center text-[12px] md:text-[14px] p-1 md:px-1.5 w-auto h-auto";
                                } else {
                                    status = "Past";
                                    statusClasses = "bg-red-100 text-red-600 rounded-xl text-center text-[12px] md:text-[14px] p-1 md:px-1.5 w-auto h-auto";
                                }

                                return (
                                    <tr 
                                        key={title}
                                        className='h-[40px] md:h-[50px] items-center border-b border-b-slate-200'
                                    >
                                        <td className='p-2 md:p-4'>
                                            <input 
                                                type="checkbox" 
                                                checked={isChecked} 
                                                onChange={() => handleCheck(title)}
                                            />
                                        </td>
                                        <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>
                                            {isMobile ? formattedDateMobile : formattedDate}
                                        </td>
                                        <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>
                                            {formattedTitle}
                                        </td>
                                        <td className='p-1.5 md:p-1.5 text-left font-[Inter]'>
                                            <div className={statusClasses}>{status}</div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
            {upcomingDates?.length > 5 && (
                <button 
                    className=' text-shi-green hover:underline mt-2 md:mt-4 text-sm md:text-[16px] text-left'
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? 'See Less' : 'See All'}
                </button>
            )}

            <h2 className='w-auto text-[16px] md:text-xl font-semibold mt-5 mb-3'>Past Deadlines</h2>
            {/* <div className='overflow-x-auto'> */}
            <div className='overflow-x-auto'>
            <table className='w-full table-auto bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]'>
                        <thead>
                            <tr className='bg-slate-200 h-[35px] md:h-[50px] items-center rounded-t-lg'>
                                <th className='p-2 md:p-4'></th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Date</th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Name</th>
                                <th className='p-2 md:p-4 text-sm md:text-[16px] text-left'>Status</th>
                            </tr>
                        </thead>
                <tbody className=''>
                    {(showAllPastDates ? pastDates : pastDates.slice(0, 5)).map(({title, date, checked}) => {
                        const formattedTitle = formatTitle(title);
                        const formattedDate = formatDate(date);
                        const formattedDateMobile = formatDateForMobile(date);
                        const isChecked = checkedDates[title] || false; 
                        const itemDate = new Date(date);
                        let status;
                        let statusClasses; 

                        if (isChecked) {
                            status = "Completed";
                            statusClasses = "bg-green-100 text-green-600 rounded-xl text-center text-[12px] md:text-[14px] p-1 md:px-1.5";
                        }  else {
                            status = "Past";
                            statusClasses = "bg-red-100 text-red-600 rounded-xl text-center text-[12px] md:text-[14px] p-1 md:px-1.5";
                        }

                    return (
                        <tr 
                            key={title}
                            className='h-[40px] md:h-[50px] items-center border-b border-b-slate-200'
                        >
                                <td className='p-2 md:p-4'>
                                    <input 
                                        type="checkbox" 
                                        checked={isChecked || false} 
                                        onChange={() => handleCheck(title)}
                                        className='ml-5'
                                        />
                                </td>
                                {isMobile ?
                                <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>{formattedDateMobile}</td>
                                :
                                <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>{formattedDate}</td>
                                }
                                <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>{formattedTitle}</td>
                                <td className='p-2 md:p-4 text-[12px] md:text-sm font-[Inter] text-left'>
                                    <div className={`text-left font-[Inter] ${statusClasses}`}>{status}</div>
                                </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
            </div>
                {pastDates?.length > 5 && (
                <button 
                    className=' text-shi-green hover:underline mt-2 md:mt-4 text-sm md:text-[16px] text-left'
                    onClick={() => setShowAllPastDates(!showAllPastDates)}
                >
                    {showAllPastDates ? 'See Less' : 'See All'}
                </button>
            )}
        </div>
    </div>

    );
}

export default UpcomingDates;